jQuery(document).ready(function () {
    jQuery('.wm-productCarousel__carousel').each(function () {
        jQuery(this).slick({
            slidesToShow: 1,
            dots: false,
            arrows: true,
            prevArrow: jQuery(this).siblings().find('.wm-productCarousel__arrow.-prev'),
            nextArrow: jQuery(this).siblings().find('.wm-productCarousel__arrow.-next'),
            infinite: false,
            asNavFor: jQuery(this).siblings('.wm-productCarousel__navigation'),
            fade: true,
            adaptiveHeight: true
        });
        jQuery(this).siblings('.wm-productCarousel__navigation').slick({
            slidesToShow: 3,
            dots: false,
            arrows: false,
            infinite: false,
            focusOnSelect: true,
            asNavFor: jQuery(this),
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
            ]
        });
        jQuery(this).on('beforeChange', () => {
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery(this).offset().top - 180
            }, 500);
        });
    });
});
